import { render, staticRenderFns } from "./TreatmentStepsBase.vue?vue&type=template&id=54b8a5d4&scoped=true"
import script from "./TreatmentStepsBase.vue?vue&type=script&lang=ts"
export * from "./TreatmentStepsBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b8a5d4",
  null
  
)

export default component.exports